<template>
    <div id="modal-reanalise-certificacao">
        <el-dialog
            :title="$t('certification.messages.generate_new_analysis')"
            width="500px"
            top="5vh"
            :visible="show"
            @close="closeDialog"
        >
            <BlocoListarAtivasCertificao
                @emitIdsCertificacaoTipo="idsCertificacaoTipo"
                :checked-default-by-name="checked"
            />
            <hr />
            <p>
                <b>{{ $tc('certification.words.territory') }}:</b>
                {{ rowInfo.geometrias[0].nomeTerritorio }}
            </p>
            <p>
                <b>{{ $tc('certification.words.locality') }}:</b>
                {{ rowInfo.geometrias[0].municipioTerritorioNome }} /
                {{ rowInfo.geometrias[0].estadoTerritorioSigla }}
            </p>
            <div class="margin-p">
                <b>{{ $tc('certification.messages.linked_cars') }}:</b>
                <ul class="lista-car">
                    <li
                        v-for="car in rowInfo.cars"
                        :key="car.codigo"
                        class="lista"
                    >
                        <span>{{ car.codigo }}</span>
                    </li>
                </ul>
            </div>
            <div class="margin-p margin-p-block">
                <b>{{ $tc('certification.words.representatives') }}:</b>
                <ul class="lista-representante">
                    <li
                        v-for="rep in rowInfo.representantes"
                        :key="rep.nomeRepresentante"
                        class="lista"
                    >
                        <span>{{ rep.nomeRepresentante }}</span>
                    </li>
                </ul>
            </div>
            <div class="d-flex flex-direction justify-content-between py-3">
                <el-button
                    slot="footer"
                    size="mini"
                    :disabled="loading"
                    @click="closeDialog"
                    >{{ $tc('certification.words.back') }}</el-button
                >
                <el-button
                    :loading="loading"
                    slot="footer"
                    size="mini"
                    type="primary"
                    @click="realizarAnalise"
                    >{{ $tc('certification.words.continue') }}</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script>
import BlocoListarAtivasCertificao from '@/modules/certification/views/components/BlocoListarAtivasCertificao.vue';
import CertificacaoService from '@/services/CertificacaoService';
export default {
    name: 'ModalGerarAnalise',
    components: {
        BlocoListarAtivasCertificao
    },
    emits: ['update:show'],
    props: {
        show: {
            type: Boolean,
            required: true
        },
        rowInfo: {
            type: Object,
            required: true
        },

        checked: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            certificacao: {
                idsTerritorio: [],
                idsCertificacaoTipo: []
            },
            loading: false
        };
    },

    methods: {
        closeDialog() {
            this.clearFields();
            this.$emit('update:show', false);
        },
        idsCertificacaoTipo(idsCertificacaoTipo) {
            this.certificacao.idsCertificacaoTipo = idsCertificacaoTipo.idsTipo;
        },
        clearFields() {
            this.certificacao.idsTerritorio = [];
        },
        atualizarTabela() {
            this.$emit('atualizarTabela');
        },
        async realizarAnalise() {
            if (!this.rowInfo.geometrias.length) {
                this.$notify.error({
                    message:
                        'Necessário inserir ao menos um território para realizar análise.'
                });
                return;
            }
            if (!this.certificacao.idsCertificacaoTipo.length) {
                this.$notify.error({
                    message:
                        'Necessário selecionar ao menos um tipo de certificação para realizar análise.'
                });
                return;
            }

            this.certificacao.idsTerritorio = this.rowInfo.geometrias.map(
                territorio => territorio.nomeTerritorio
            );

            try {
                this.loading = true;
                await CertificacaoService.InserirCertificacaoTerritorio({
                    idTerritorio: this.certificacao.idsTerritorio,
                    idCertificacaoTipo: this.certificacao.idsCertificacaoTipo
                });
                this.$notify.success({
                    message: 'Certificações enviadas para análise com sucesso!'
                });
                this.atualizarTabela();
                this.closeDialog();
            } catch (error) {
                this.$notify.error({
                    message:
                        'Erro na requisição de enviar os territórios certificados.'
                });
                this.clearFields();
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.el-dialog__header {
    background: #f6f6f6;
    color: #3b3b3b;
    padding: 12px 20px 20px;
}
.el-dialog__body {
    padding: 20px 20px 30px 20px;
    word-break: break-word;
}
.el-dialog__headerbtn {
    top: 10px;
}
.el-dialog__headerbtn:hover .el-icon-close {
    color: #ffffff;
}

.el-dialog__title {
    color: var(--primary);
    font-weight: bold;
}
</style>
